// extracted by mini-css-extract-plugin
export default {"textInput":"styles_textInput__jwE3X","form":"styles_form__3K8TD","formDiv":"styles_formDiv__W3LVR","clientView":"styles_clientView__ixTt0","ui-spin":"styles_ui-spin__bYswo"};